import { createAction } from "redux-starter-kit";
import { APP_TITLES_SET } from "../actionTypes";
import { getATitleApi } from "../../api/titles";

export const appSetTitleAction = createAction(APP_TITLES_SET);

export function loadATitleRequestAction(titleID, toast, history) {
  return async dispatch => {
    try {
      let aTitle = await getATitleApi(titleID);
      dispatch(appSetTitleAction({ title: aTitle }));
    } catch (e) {
      if (e.message === "404") {
        history.push(`${process.env.REACT_APP_URL_ROOT}404`);
      } else {
        toast.error(e.toString());
      }
    }
  };
}
